import "./BiomarkerBasicDetailsViewComponent.scss";
import ButtonComponent from "../../../../../shared/components/core/button/ButtonComponent";
import EditIcon from "@mui/icons-material/Edit";
import React from "react";
import {Grid} from "@material-ui/core";
import DetailsDataKeyValueComponent
    from "../../../../../shared/components/details-data-key-value-component/detailsDataKeyValueComponent";
import commonService from "../../../../../shared/services/common.service";

interface BiomarkerBasicDetailsViewComponentProps {
    biomarkerBasicDetails?: any;
    canEdit?: boolean;
    onEditModeOpen: () => void;
}

const BiomarkerBasicDetailsViewComponent = (props: BiomarkerBasicDetailsViewComponentProps) => {
    const {biomarkerBasicDetails, onEditModeOpen, canEdit} = props;

    return (
        <div className={'biomarker-basic-details-view-component details-tab-data-content'}>
            <div className="details-tab-data-header">
                <div className="view-and-edit-title">Biomarker Details</div>
                {canEdit && <div className={'edit-action-button'}>
                    <ButtonComponent
                        className={"white-space-nowrap"}
                        type="button"
                        color={"primary"}
                        variant={"outlined"}
                        startIcon={<EditIcon/>}
                        fullWidth={true}
                        handleClick={onEditModeOpen}
                    >
                        Edit Details
                    </ButtonComponent>
                </div>
                }
            </div>
            <div className="details-tab-data-body">
                <Grid container spacing={2} className="pdd-top-0">
                    <Grid item xs={12} sm={12} md={6} xl={6}>
                        <DetailsDataKeyValueComponent
                            title={"Biomarker Name"}> {biomarkerBasicDetails?.name ? commonService.capitalizeFirstLetterOfEachWord(biomarkerBasicDetails?.name) : 'N/A'} </DetailsDataKeyValueComponent>
                        <DetailsDataKeyValueComponent
                            title={"Report Type"}> {biomarkerBasicDetails?.reportFormat || 'N/A'} </DetailsDataKeyValueComponent>
                        <DetailsDataKeyValueComponent
                            title={"Sample Collection Device Name"}> {biomarkerBasicDetails?.sampleCollectionDeviceName ? commonService.capitalizeFirstLetterOfEachWord(biomarkerBasicDetails?.sampleCollectionDeviceName) : 'N/A'} </DetailsDataKeyValueComponent>
                        {/*<DetailsDataKeyValueComponent*/}
                        {/*    title={"Description"}> {biomarkerBasicDetails?.description || 'N/A'} </DetailsDataKeyValueComponent>*/}
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} xl={6}>
                        {/*<DetailsDataKeyValueComponent*/}
                        {/*    title={"Biomarker Code"}> {biomarkerBasicDetails?.code || 'N/A'} </DetailsDataKeyValueComponent>*/}
                        <DetailsDataKeyValueComponent
                            title={"Sample Type"}> {biomarkerBasicDetails?.sampleType ? commonService.capitalizeFirstLetterOfEachWord(biomarkerBasicDetails?.sampleType) : 'N/A'} </DetailsDataKeyValueComponent>
                    </Grid>
                </Grid>
            </div>
        </div>
    );

};

export default BiomarkerBasicDetailsViewComponent;
